import {ProductConfigurationField} from "../inputs/ProductConfigurationInputProps";
import {FormInputField} from "../../components/forms/FormInputField";
import {fieldModifierAttributes} from "../FieldModifiers";
import {useFormContext} from "react-hook-form";
import {shouldRevalidate} from "../validation/utils";
import {partial} from "lodash";

const keyToImgSrc = new Map<string, string>([
    ['RoutingNumber', '/A.svg'],
    ['BankAccountNumber', '/B.svg'],
    ['CheckStartNumber', '/C.svg']
]);

export const BankingInfoField: ProductConfigurationField =
    ({config, onFieldBlur = () => void 0}) => {

    const {trigger, getFieldState} = useFormContext();

    const revalidate = async () => {
        if (shouldRevalidate(getFieldState(config.configurationKey))) {
            await trigger(config.configurationKey);
        }
    }

    const imgSrc = keyToImgSrc.get(config.configurationKey);

    return (
        <FormInputField name={config.configurationKey}
                        label={
                            <>
                                {imgSrc &&
                                    <img src={imgSrc}
                                         alt={config.label}
                                         style={{height: '22px'}}
                                         className={'pe-1'}
                                    />
                                }
                                {config.label}
                            </>
                        }
                        type="text"
                        inputMode={config.inputType.name === "Numeric" ? "numeric" : undefined}
                        onChange={async value => {
                            await revalidate();
                            return value;
                        }}
                        onBlur={partial(onFieldBlur, config)}
                        isSecure={config.isSecure}
                        {...fieldModifierAttributes(config)}
        />
    );
}